import { ChangeDetectionStrategy, Component, EventEmitter, Output, Input } from "@angular/core";
import { Observable } from "rxjs";
import { Tradable } from "@models/interfaces/tradable";

@Component({
	selector: "tradable-list-empty",
	templateUrl: "./tradable-list-empty.component.html",
	styleUrls: ["./tradable-list-empty.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TradableListEmptyComponent {
	@Output() public refetchData: EventEmitter<void> = new EventEmitter<void>();
	@Input() public filteredList$: Observable<Tradable[]>;
}
